var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './AnalysisCard.scss';
import { createGetStreamEndpoint } from '@sonar-software/sonar-http';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { MailOutlined } from '@ant-design/icons';
import Markdown from 'react-markdown';
import { SalesforceLogo } from '@ui/icons';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { When } from 'react-if';
import { Button, Flex } from 'antd';
import { COPY_SPECIFIC, EMAILS } from '@sonar-software/sonar-ts-constants';
import React, { useState } from 'react';
import { SanitizedHtml, SonarCard, SparkleIcon } from '@ui/general';
import { useOnMount, useSonarObjectReference } from '@hooks';
const titleMap = {
    [SonarObjectType.SalesforceApexClass]: COPY_SPECIFIC.AI_EXPLAIN,
    [SonarObjectType.SalesforceValidationRule]: COPY_SPECIFIC.AI_FIX
};
const urlMap = {
    [SonarObjectType.SalesforceApexClass]: (id) => `/api/v3/open-ai/chat/apex-class/${id}`,
    [SonarObjectType.SalesforceValidationRule]: (id) => `/api/v3/open-ai/chat/validation-rule-issue/${id}`
};
export const AnalysisCard = ({ sonarObjectId, type }) => {
    var _a;
    const { sourceUrl } = useSonarObjectReference(sonarObjectId);
    const [text, setText] = useState('');
    const [hasLoaded, setHasLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    useOnMount(() => {
        const urlFn = urlMap[type];
        const url = urlFn ? urlFn(sonarObjectId) : '';
        if (!url) {
            setHasError(true);
        }
        const load = createGetStreamEndpoint(url);
        load().then((response) => __awaiter(void 0, void 0, void 0, function* () {
            const reader = response.data;
            if (!reader) {
                setHasError(true);
                setHasLoaded(true);
                return;
            }
            const decoder = new TextDecoder();
            while (true) {
                // eslint-disable-next-line no-await-in-loop
                const { done, value } = yield reader.read();
                if (done) {
                    break;
                }
                const stringValue = decoder.decode(value, { stream: true });
                setText((current) => current + stringValue);
            }
            setHasLoaded(true);
        }));
    });
    const displayError = hasError || (hasLoaded && !text);
    return (React.createElement(SonarCard, { className: 'ai-analysis-card', extra: React.createElement(Button, { className: 'open-in-salesforce-button', href: sourceUrl, icon: React.createElement(SalesforceLogo, { color: 'currentColor' }), target: '_blank', type: 'default' }, COPY_SPECIFIC.OPEN_IN_SALESFORCE), icon: React.createElement(SparkleIcon, null), title: (_a = titleMap[type]) !== null && _a !== void 0 ? _a : COPY_SPECIFIC.AI_EXPLAIN },
        React.createElement(When, { condition: !displayError && !text },
            React.createElement(LoadingSpinner, { size: 'large', spinning: true })),
        React.createElement(When, { condition: displayError },
            React.createElement("p", null,
                React.createElement(SanitizedHtml, { as: 'span', html: COPY_SPECIFIC.AI_RESPONSE_FAILURE(EMAILS.SUPPORT) })),
            React.createElement(Flex, { align: 'center', vertical: true },
                React.createElement(Button, { icon: React.createElement(MailOutlined, null), type: 'default' }, COPY_SPECIFIC.CONTACT_SUPPORT))),
        React.createElement(Markdown, null, text)));
};
